export const flagTitle = "mGXuTc";
export const unflagTitle = "lSeUid";
export const markCompleteTitle = "K1mLvc";
export default {flagTitle,unflagTitle,markCompleteTitle};